'use client';
import React from 'react';
import Link from 'next/link';
import { useParams } from 'next/navigation';

export default function ErrorPage() {
  const params = useParams();

  return (
    <section className='bg-white w-screen h-screen flex justify-center items-center  '>
      <div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
        <div className='mx-auto max-w-screen-sm text-center'>
          <h1 className='mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600'>{'🙁'}</h1>
          <p className='mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl '>予期せぬ問題が発生しました</p>
          <p className='mb-4 text-lg font-light text-gray-500 '>現在、システムエラーが発生しております。誠に申し訳ございませんが、しばらくしてから再度お試しください。</p>
          <Link
            href={`/${params.school}/`}
            className='inline-flex underline text-black bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-lg px-5 py-2.5 text-center dark:focus:ring-primary-900 my-4'>
            ホームページに戻る
          </Link>
        </div>
      </div>
    </section>
  );
}
